<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Sobre Nosotros</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Sobre Nosotros</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section style="text-align: justify;" class="customer-support-area ptb-100">

    <section class="customer-support-area ">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="customer-title">
                        <h2>Nuestra Historia</h2>
                        <p>enCloud nació en México con el compromiso de ofrecer soluciones tecnológicas accesibles y de
                            vanguardia. Hoy, nos enorgullece ser reconocidos como un P<strong>Proveedor
                                de Servicios Gestionados (MSP) y un Proveedor de Servicios en la Nube (CSP)</strong>, brindando una combinación única de
                            soluciones que garantizan a nuestros clientes las herramientas y el soporte necesarios para
                            alcanzar sus objetivos tecnológicos.</p>
                    </div>

                    <ul class="custom-list">
                        <p><strong>Hitos clave en nuestra historia:</strong></p>
                        <li><strong>Fundación y propósito - </strong> Nacimos con la misión de acercar tecnología innovadora a empresas y organizaciones.</li>
                        <li><strong>Expansión de servicios -  </strong> Ampliamos nuestra oferta para cubrir diversas necesidades en la nube y la gestión de infraestructura.</li>
                        <li><strong>Desarrollo de tecnología propia –  </strong> Creamos soluciones personalizadas para optimizar el rendimiento y la seguridad.</li>
                        <li><strong>Compromiso con la seguridad –   </strong>Implementamos estándares de protección avanzados para resguardar la información de nuestros clientes.</li>
                        <li><strong>Alianzas estratégicas –   </strong>Colaboramos con empresas e instituciones clave para seguir innovando en el sector tecnológico.</li>
                    </ul>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="support-img">
                        <img height="100%" src="assets/img/shape/lnve.png" alt="Image">
                    </div>
                </div>
            </div>
        </div>
    </section>


    <div class="pt-70"></div>
    <div class="container">
        <div class="row align-items-center">
            <div style="padding-right: 0px" class="row">
                <div style="padding-right: 0px" class="col-lg-4 col-sm-6">
                    <div class="single-technology">
                        <div class="technology-icon-bg">
                            <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                            <i class="fa-solid fa-microchip"></i>
                        </div>
                        <h3>Misión</h3>
                        <p>Facilitar el acceso a servicios de nube gestionados y soluciones personalizadas que permitan
                            a empresas, Empresas emergentes (startups), investigadores y usuarios individuales optimizar
                            sus operaciones y
                            avanzar hacia la transformación digital.</p>
                    </div>
                </div>
                <div style="padding-right: 0px" class="col-lg-4 col-sm-6">
                    <div class="single-technology active">
                        <div class="technology-icon-bg">
                            <img src="assets/img/shape/technology-icon-bg.png" alt="Image"><i
                                class="fa-solid fa-server"></i>
                        </div>
                        <h3>Visión</h3>
                        <p>Ser la empresa líder regionalmente e internacionalmente como MSP y CSP, proporcionando una
                            oferta integral que combine la gestión experta de servicios tecnológicos con la
                            infraestructura de nube más avanzada.</p>
                    </div>
                </div>
                <div style="padding-right: 0px" class="col-lg-4 col-sm-6">
                    <div class="single-technology">
                        <div class="technology-icon-bg">
                            <img src="assets/img/shape/technology-icon-bg.png" alt="Image"><i
                                class="fa-solid fa-shield-heart"></i>
                        </div>
                        <h3>Nuestros Valores</h3>

                        <div class="solutions-wrap">
                            <ul class="custom-list">
                                <li> Confianza y Seguridad</li>
                                <li> Innovación Continua</li>
                                <li> Sostenibilidad y Responsabilidad</li>
                                <li> Colaboración y Cercanía</li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="pt-70"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="solutions-wrap">
                    <div class="solutions-title">
                        <h2>Qué Nos Hace Únicos</h2>
                    </div>
                    <ul class="solutions-list">
                        <li><i style="size: 15px; weight: 600;" class="flaticon-right"></i> <strong>Somos MSP y CSP:</strong> Ofrecemos un servicio
                            integral, desde la provisión de infraestructura en la nube hasta la gestión activa de
                            servicios tecnológicos. Esto garantiza que nuestros clientes puedan enfocarse en su
                            crecimiento mientras nosotros manejamos la tecnología.</li>
                        <li><i class="flaticon-right"></i> <strong>Gestión Proactiva:</strong> Como MSP, nos anticipamos
                            a problemas tecnológicos con monitoreo continuo, mantenimiento preventivo y soporte
                            personalizado.</li>

                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="solutions-wrap">

                    <ul class="solutions-list">
                        <li><i class="flaticon-right"></i> <strong>Infraestructura de Nube Personalizada:</strong> Como
                            CSP, proporcionamos soluciones flexibles de almacenamiento, procesamiento y hosting para
                            cualquier tamaño de negocio o proyecto.</li>
                        <li><i class="flaticon-right"></i> <strong>Integración Total:</strong> Combinamos servicios
                            gestionados y recursos en la nube para optimizar la operación de nuestros clientes,
                            reduciendo costos y aumentando la eficiencia.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="pt-70"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="solutions-wrap">
                    <div class="solutions-title">
                        <h2>¿Qué Ofrecemos Como MSP?</h2>
                    </div>
                    <ul class="solutions-list">
                        <li><i class="flaticon-right"></i>Gestión completa de infraestructura TI y servicios en la nube.
                        </li>
                        <li><i class="flaticon-right"></i>Monitoreo y soporte proactivo para evitar interrupciones en
                            tus operaciones.</li>
                        <li><i class="flaticon-right"></i>Optimización de recursos tecnológicos para reducir costos y
                            maximizar el rendimiento.</li>
                        <li><i class="flaticon-right"></i>Servicios de backup y recuperación ante desastres diseñados a
                            medida.</li>

                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="solutions-img">
                    <img src="assets/img/shape/tdi5thd.png" alt="Image">
                </div>
            </div>
        </div>
    </div>
    <div class="pt-70"></div>
    <div class="container">
        <div class="row align-items-center">

            <div class="col-lg-6 col-md-12">
                <div class="solutions-wrap">
                    <div class="solutions-title">
                        <h2>¿Qué Ofrecemos Como CSP?</h2>
                    </div>
                    <ul class="solutions-list">
                        <li><i class="flaticon-right"></i>Infraestructura escalable de nube para almacenamiento masivo,
                            hosting y procesamiento de datos.</li>
                        <li><i class="flaticon-right"></i>Soluciones diseñadas específicamente para machine learning,
                            videojuegos, y aplicaciones empresariales.</li>
                        <li><i class="flaticon-right"></i>Acceso a tecnología propia, como routers diseñados y
                            fabricados por enCloud, para un rendimiento superior.</li>
                        <li><i class="flaticon-right"></i>Herramientas avanzadas para investigadores y centros
                            educativos.</li>

                    </ul>
                </div>

            </div>
            <div class="col-lg-6 col-md-12">
                <div class="solutions-img">
                    <img src="assets/img/shape/kt5gml.png" alt="Image">
                </div>
            </div>
        </div>
    </div>

    <div class="pt-70"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="solutions-wrap">
                    <div class="solutions-title">
                        <h2>Nuestros Logros</h2>
                    </div>
                    <ul class="solutions-list">
                        <li><i class="flaticon-right"></i> <strong>Infraestructura de Clase Mundial:</strong>
                            Nuestros centros de datos están listos para garantizar alta disponibilidad y baja latencia
                            en todos nuestros servicios.</li>
                        <li><i class="flaticon-right"></i> <strong>Alianzas Estratégicas:</strong>
                            Formamos una alianza con importantes universidades e instituciones de investigación para
                            proporcionar acceso a nuestras soluciones de computación en la nube, impulsando proyectos
                            científicos y tecnológicos.</li>
                        <li><i class="flaticon-right"></i> <strong>Desarrollo Tecnológico:</strong>
                            Diseñamos y lanzamos nuestra línea de <strong>“Access Pods”</strong>, reconocidos por su
                            eficiencia energética y capacidad para manejar entornos de alto tráfico. Estos productos han
                            sido adoptados por empresas en sectores como telecomunicaciones y manufactura.</li>

                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="solutions-wrap">

                    <ul class="solutions-list">
                        <li><i class="flaticon-right"></i> <strong>Liderazgo en Innovación:</strong>
                            Introdujimos soluciones avanzadas de <strong>Machine Learning as a Service (MLaaS)</strong>,
                            permitiendo a nuestros clientes entrenar modelos de inteligencia artificial de manera
                            eficiente sin necesidad de adquirir infraestructura propia.</li>
                        <li><i class="flaticon-right"></i> <strong>Soporte a la Industria de Videojuegos:</strong>
                            Desarrollamos un servicio especializado de servidores dedicados para videojuegos, logrando
                            que nuestros clientes optimicen la experiencia multijugador.</li>
                        <li><i class="flaticon-right"></i> <strong>Crecimiento de Clientes y Satisfacción:</strong>
                            Gracias a nuestro enfoque personalizado y a un equipo de soporte técnico disponible 24/7
                            logramos incrementar nuestro número de clientes activos.</li>

                    </ul>
                </div>
            </div>
        </div>
    </div>

</section>




<app-sites-area [ptb]="ptb"></app-sites-area>



<app-clients-says></app-clients-says>

<app-clients [pt]="pt" [pb]="pb"></app-clients>